import { render, staticRenderFns } from "./QuizReport.vue?vue&type=template&id=b9881ae6&scoped=true"
import script from "./QuizReport.vue?vue&type=script&lang=js"
export * from "./QuizReport.vue?vue&type=script&lang=js"
import style0 from "./QuizReport.vue?vue&type=style&index=0&id=b9881ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9881ae6",
  null
  
)

export default component.exports